function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.488 29.709a4.366 4.366 0 1 1-.025-8.732 4.366 4.366 0 0 1 .025 8.732zm0-7.829a3.476 3.476 0 1 0 0 6.953 3.476 3.476 0 0 0 0-6.953z",
  fill: "#E4ECFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.488 27.52a2.177 2.177 0 1 1-.025-4.354 2.177 2.177 0 0 1 .025 4.354zm0-3.438a1.237 1.237 0 0 0-1.237 1.237 1.274 1.274 0 1 0 2.448-.491 1.236 1.236 0 0 0-1.21-.746zM19.63 29.709a4.366 4.366 0 1 1-.024-8.732 4.366 4.366 0 0 1 .025 8.732zm0-7.829a3.474 3.474 0 1 0-.02 6.948 3.474 3.474 0 0 0 .02-6.948z",
  fill: "#E4ECFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.63 27.52a2.177 2.177 0 1 1-.025-4.354 2.177 2.177 0 0 1 .025 4.354zm0-3.438a1.237 1.237 0 0 0-1.237 1.237 1.274 1.274 0 1 0 2.448-.491 1.236 1.236 0 0 0-1.21-.746zM28.893 29.709a4.366 4.366 0 1 1 .002-8.731 4.366 4.366 0 0 1-.002 8.731zm0-7.829a3.474 3.474 0 1 0 0 6.949 3.474 3.474 0 0 0 0-6.949z",
  fill: "#E4ECFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.893 27.52a2.178 2.178 0 1 1-.002-4.357 2.178 2.178 0 0 1 .002 4.357zm0-3.438a1.237 1.237 0 1 0 0 2.472 1.237 1.237 0 0 0 0-2.47v-.002zM69.772 5.175h-8.15V.025l.617.284a27.309 27.309 0 0 1 6.68 4.094l.853.772zm-7.26-.9h4.835a29.494 29.494 0 0 0-4.836-2.865v2.865z",
  fill: "#E4ECFF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m24.267 25.294-.421-1.237a4.453 4.453 0 0 0-8.374-.148l-.408 1.076-.421-1.076a4.453 4.453 0 0 0-8.51.631l-.074.346H1.237V20.07H0V0h62.128v5.17h.334v19.716h-29.19l-.074-.346a4.453 4.453 0 0 0-8.572-.482l-.359 1.236zm9.771-1.3h27.509V6.061h-.337V.94H.767v18.293h1.237v4.811h3.228a5.343 5.343 0 0 1 9.709-1.237 5.33 5.33 0 0 1 9.2.1 5.343 5.343 0 0 1 9.769 1.163l.128-.076z",
  fill: "#E4ECFF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M1.831 23.364H2.87l.025-2.053H1.856l-.025 2.053zM77.91 25.937h-3.129l.111-.544c.05-.202.075-.41.074-.618 0-.254-.029-.507-.086-.754l-.111-.544h3.142l-.001 2.46zm-2.066-.89h1.175v-.68h-1.236v.407c.027.09.048.18.062.272h-.001zM64.503 25.937h-2.585v-2.474h2.61l-.087.519c-.045.258-.069.52-.073.78.002.22.022.44.062.657l.073.518zm-1.695-.891h.68v-.68h-.693l.013.68z",
  fill: "#E4ECFF"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M62.376 26.382H33.26v-.618c.006-.09.006-.181 0-.272a5.608 5.608 0 0 0 0-.656l-.062-.507h29.19l-.012 2.053zm-28.213-.89h27.3v-.273h-27.3a1.9 1.9 0 0 1 0 .272zM5.557 26.37H.767v-2.04H6.11l-.062.556a4.809 4.809 0 0 0 0 .606 3.707 3.707 0 0 0 0 .383v.495h-.49zm-3.92-.89h3.447a1.828 1.828 0 0 1 0-.26H1.621l.015.26zM77.763 23.933h-3.18l-.074-.334a5.678 5.678 0 0 0-5.356-3.612 4.789 4.789 0 0 0-4.626 3.612l-.087.334h-2.547V5.145h12.492l3.377 8.967.001 9.821zm-2.474-.891h1.608v-8.844l-3.092-8.163h-11v17.007h.977a5.666 5.666 0 0 1 5.393-3.933c2.325 0 5.257 1.5 6.085 3.933h.03z",
  fill: "#E4ECFF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M76.476 14.99h-5.69l-3.154-2.646h-4.54V6.296h10.774l2.61 8.695zm-5.368-.89h4.168l-2.078-6.914h-9.215v4.267h3.983l3.142 2.647zM69.628 29.709a4.63 4.63 0 1 1 .002-9.259 4.63 4.63 0 0 1-.002 9.259zm0-8.303a3.685 3.685 0 1 0 .001 7.37 3.685 3.685 0 0 0 0-7.37z",
  fill: "#E4ECFF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M69.629 27.387a2.31 2.31 0 1 1-.003-4.619 2.31 2.31 0 0 1 .002 4.62zm0-3.646a1.312 1.312 0 1 0 0 2.622 1.312 1.312 0 0 0 0-2.62v-.002zM66.481 14.397h-3.364v1.237h3.364v-1.237zM61.766 19.17H1.336v.892h60.43v-.891z",
  fill: "#E4ECFF"
});

var SvgStraightTruck = function SvgStraightTruck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 30,
    viewBox: "0 0 78 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStraightTruck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/straightTruck.a8feced2.svg";
export { ForwardRef as ReactComponent };